/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { TextField, MuiThemeProvider, Tabs,
         Tab, Badge, Paper, Button, Typography, Select, MenuItem,    
         CircularProgress} from '@material-ui/core';

import  { lightBlue } from '@material-ui/core/colors';
import Ticket from './Ticket.js';

import { SalesforceConfig, ServicenowConfig } from './TicketConfig.js';

import PDFViewer from './Components/PDFViewer.js';

import Actions from '../../fluid/Actions/ActionFactory.js';


import toPx from 'unit-to-px';
import RecoResults from './Components/RecoResults.js';
import RecoFilters from './Components/RecoFilters.js';
import ResultViewer from './Components/ResultViewer.js';

const blue_theme = createMuiTheme({ 
    palette: { 
        primary: {
            main: lightBlue[600]
        } 
    },
    typography: {
        useNextVariants: true,
        h6: {
            fontSize: '0.95rem',
            lineHeight: 1.3
        },
        body2Next: {
            fontSize: "0.75rem"
        }
    }
})


const styles = theme => ({
    tabsIndicator: {
        backgroundColor: '#1890ff',
        border: '2px solid #1890ff'
    },
    badgePadding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    indicator: {
        height: 3
    },
    text: {
        color: '#2f3b4e'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
})


class Recommendation extends Component {
    state = {
        recoResolutions : [],
        copiedResolution: '',
        resolutionText: '',
        ticketConfig: SalesforceConfig,
        selectedResult: {},
        selectedResultItem: 0,
        isLoading: true,
        filteredResolutions: [],
        filters: [
            {
                value: 'all',
                label: 'All'
            },
            {
                value: 'ticket',
                label: 'Tickets'
            },
            {
                value: 'pdf',
                label: 'PDF'
            },
            {
                value: 'doc',
                label: 'Doc'
            }
        ],
        selectedFilter: 'all',
        detailViewerdata: {},
        selectedPDFLink: ''
        
    }

    componentDidMount = () => {
       // this.getRecoResolutions();
       this.setDefaults();
    }

    setDefaults = () => {
        let { recoResolutions } = this.props;
       this.setState({ recoResolutions: recoResolutions,  filteredResolutions:  recoResolutions }, () => {
        
        let firstResult = this.state.recoResolutions[0];

        let firstResultType =  firstResult.iu_record_src_info.iu_content_type.sub_class; 

        if(firstResultType == 'pdf') {
            let link = firstResult.iu_record_src_info.iu_record_nav_info.source[0].link;
            let generatedLink = this.getPDFLink(link, firstResult, 0 );
         
        } else {
            this.setState({ selectedResult: firstResult,  selectedResultItem: 0 , isLoading: false}, function(){
                
            })
        }
       
        });
    }

    submitResolution = () => {

    }

    copyResolution = ( resolution ) => {
        this.updateResolution( resolution );
    }

    updateResolution = ( copiedResolution ) => {
        let resolutionText  = this.state.resolutionText + " " + copiedResolution + '\n\n';
        this.setState({ resolutionText: resolutionText });
    }

    handleResolution = (text) => {
        this.setState({ resolutionText: text})
    }


    getRecoResolutions = () => {        
        Actions('http_request', {
            url: 'http://localhost:9000/getRecommendations',
            method: 'get',
            data : {

            }
        }).then(res => {
         
            let result = res.data.result;
            this.setState({ recoResolutions: result, selectedResult: result[0], filteredResolutions:  result }, () => {
                let selectedResType = this.state.selectedResult.iu_record_src_info.iu_content_type.sub_class
                let selectedResult = this.state.selectedResult;

                this.setState({ isLoading: false})

                
                if(selectedResType == 'ticket' || selectedResType == 'sm' || selectedResType == 'csv'){
                    let selectedTicketId = selectedResult.wv_field_list.find((element) => element.name == 'id').value;
                 
                    this.getTicketDetails(selectedTicketId)
                } else if( selectedResType == 'pdf'){

                }
               
            });

        })
    }

    getTicketDetails = ( ticket_id ) => {

        let ticketData; 
        Actions('http_request', {
            url: 'http://localhost:9000/getTicketDetails?ticket_id='+ ticket_id,
            method: 'get',
          
        }).then(res => {
            ticketData = res.data.result;

            this.setState({ detailViewerdata : ticketData, isLoading: false })
        })

        return this.state.detailViewerdata;

      
    }

    submitResolution = () => {
        Actions('http_request', {
            url : 'http://localhost:9000/updateTicket',
            method : 'post',
            data : {
                ticket_id : this.state.ticketConfig.result.id,
                resolution : this.state.resolutionText
            }
        }).then(res => {
            console.log('Response',res)
            if(res.status === "success"){
                this.props.history.push({pathname: '/queue'})
            }else{
                this.setState({submitDisabled: false})
            }
        }).catch(err => {
            console.log(err.response)
        })
    }

    
    renderTicketToResolve = () => {
        return (
            <Ticket config={SalesforceConfig} type={"resolve"} escalate={"true"}/>
        )
    }

    renderResolutionEditor = () => {
        return (
            
                 <Paper style={{ padding: "1vw", marginTop: "8px"}} elevation = {1} >
                    
                    <TextField
                        label='Resolution'
                        fullWidth = {true}
                        name = 'Resolution'
                        multiline = {true}
                        value = {this.state.resolutionText}
                        onChange={(event) => this.handleResolution(event.target.value)}
                        rows = {12}
                        rowsMax = {12}
                        variant= 'outlined'
                        placeholder='Add Resolution'
                        InputProps={{
                            style: {fontSize: 14} 
                        }}
                    ></TextField>
                    
                    <MuiThemeProvider theme = {blue_theme}>
                        <Button 
                            style = {{marginTop: '1vh', width: '250px'}}
                            variant="contained" 
                            color="primary"
                            disabled = { this.state.resolutionText.length == 0 ? true : false}
                        >SUBMIT</Button>
                    </MuiThemeProvider>
                </Paper>
            
        )
    } 

    renderTabs = () => {
        const { classes } = this.props
        return (
            <Paper square elevation={1} style={{ margin: "5px 0px"}}>
                <Tabs
                    classes={{ indicator: classes.indicator, text: classes.text }}
                    value={this.state.tabValue}
                    indicatorColor= 'primary'
                    textColor="primary"
                    variant = 'fullWidth'
                    onChange={this.handleTabChange}
                    >
                    <Tab 
                    key = 'Resolutions'
                    className = {{indicator: classes.tabsIndicator}}
                    disabled={false} 
                    disableRipple 
                    label={<Badge 
                            className = {classes.badgePadding}
                            color="primary" badgeContent={20}>
                                Resolutions
                            </Badge>} />
                    <Tab 
                    key = 'Remediations'
                    disabled={false} 
                    disableRipple 
                    label={<Badge 
                            className = {classes.badgePadding}
                            color="primary" badgeContent={5}>
                                Remediations
                            </Badge>} />
                    <Tab 
                    key = 'KnowledgeBase'
                    disabled={false} 
                    disableRipple 
                    label={<Badge 
                            className = {classes.badgePadding}
                            color="primary" 
                            badgeContent={17}>
                                Knowledge Base
                            </Badge>} />
                </Tabs>
            </Paper>
        )
        
    }


    renderRecommendations = () => {
        return (
            <Fragment>
                <div style={{ display: "flex", flexDirection: "row", marginTop: "8px"}}>
                    <div style={{  width: "30%", height: 'calc(100vh - 270px)',  overflow: "auto", display: "block", float : "left", paddingRight: "8px"}}> 
                        {
                            this.renderResults()
                        }
                    </div>
                    <div style={{  width: "70%", height: 'calc(100vh - 400px)',   }}> 
                         {
                           !this.state.isLoading &&  (
                                <ResultViewer 
                                    selectedResult={ this.state.selectedResult}
                                    detailViewerdata= { this.state.selectedResult}
                                />
                           )
                        } 
                    </div>
                </div>
                
            </Fragment>
        )
    }

    renderResults = () => {

        return (
            <Fragment>
                <RecoResults 
                    filteredResolutions={ this.state.recoResolutions }
                    updateDetailViewer = { ( result, index) => this.updateDetailViewer( result, index) }
                    selectedResultItem = { this.state.selectedResultItem } />
           </Fragment>
        )
    }


    groupPDFFiles = () => {

    }

    getPDFLink = (link, result, index) => {
        let generatedLink;
        Actions('http_request', {
            url: '/getLinearizedFileLink?filePath=' + link,
            method: 'get',
            data : [],
             
        }).then(res => {
         
          this.setState({ selectedPDFLink : res.data.link}, () => {
           
            result.pdf_link = res.data.link;

            this.setState({ selectedResult: result, selectedResultItem: parseInt(index) , isLoading: false}, function(){
               
            })
          })

        })  
        return generatedLink;
    }

    updateDetailViewer = ( result, index ) => {
        let resultType = result.iu_record_src_info.iu_content_type.sub_class; 

        if(resultType == 'pdf') {
            let link = result.iu_record_src_info.iu_record_nav_info.source[0].link;
            let generatedLink = this.getPDFLink(link, result, index );
         
        } else {
            this.setState({ selectedResult: result, selectedResultItem: parseInt(index) }, function(){
                let selectedResult = this.state.selectedResult;
                let selectedItemType = selectedResult.iu_record_src_info.iu_content_type.sub_class;
                
               {/* if(selectedItemType == 'ticket'){
                    let selectedTicketId = selectedResult.wv_field_list.find((element) => element.name == 'id').value;
                    let ticketDetails = this.getTicketDetails(selectedTicketId);
                } */}
    
                
            })
        }
       
    }

    getFilteredResolutions = (filter_type) => {
        let { filteredResolutions, recoResolutions } = this.state
        let filterResolutionsByType;
        if(filter_type == 'all'){
            filterResolutionsByType = this.state.recoResolutions;
        } else {
            filterResolutionsByType = recoResolutions.filter((result) => result.iu_record_src_info.iu_content_type.sub_class == filter_type);
        }
        
        this.setState({
            filteredResolutions: filterResolutionsByType,
            selectedResult: filterResolutionsByType[0],
            selectedResultItem: 0,
            selectedFilter: filter_type
        }, function(){
           {/* if(filter_type == 'ticket'){
                let selectedTicketId = this.state.selectedResult.wv_field_list.find((element) => element.name == 'id').value;
                this.getTicketDetails(selectedTicketId)
            } */}
            
        })
    }

    handleChangeFilters = ( event ) => {
        this.getFilteredResolutions( event.target.value )
    }

    renderFilters = () => {
        const { classes } = this.props;
        return (
            <RecoFilters 
                    selectedFilter={this.state.selectedFilter}
                    filters={ this.state.filters }
                    handleChangeFilters={this.handleChangeFilters} 
            />
        )
       
    }

    render() {

      
        return (
            <div style = {{width : '100%'}} >
               
                <ThemeProvider theme = {blue_theme}>
                    {
                        this.state.isLoading == false && ( 
                            <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                                {/* <div style={{ width: "30%" , paddingRight: "8px"}}>
                                    <Paper square style = {{width: '100%', height: '50px', marginBottom:'3px'}}>
                                        <Typography style = {{ padding:'15px'}} variant='h6'>TICKETS</Typography>
                                    </Paper>
                                        {
                                            this.renderTicketToResolve()
                                        }
                            
                                        {
                                            this.renderResolutionEditor()
                                        }
                                </div> 
                                <div style={{ width: "70%" }}>
                                
                                   <Paper square style = {{width: '100%', height: '50px', marginBottom:'3px'}}>
                                        <Typography style = {{ padding:'15px'}} variant='h6'>RECOMMENDATIONS</Typography>
                                    </Paper> */}
                                    {/* {
                                        this.renderTabs()
                                    }  */}
                                    {/* {
                                        this.renderFilters()
                                    } */}
                                    {
                                        this.renderRecommendations()
                                    }
                                {/* </div> */}
                            </div>
                        ) 
                    }

                    {
                        this.state.isLoading == true && (
                            <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>

                             
                                <Paper square elevation={1} 
                                        style = {{width: '100%', marginTop: "8px", 
                                                height: '75vh', textAlign: 'center',
                                                }}>
                                    <CircularProgress
                                        style = {{marginTop: '30vh', verticalAlign: "middle"}}
                                        variant="indeterminate"
                                        color='primary'
                                        disableShrink
                                        className={this.props.classes.loading}
                                        size={48}
                                        thickness={4}
                                    />
                                    <Typography style={{marginTop: '10px', marginLeft: '10px', fontWeight: "bold", fontSize: "18px"}} variant='body2' color='primary'>Rendering Recommendations...</Typography>
                                 </Paper>


                            </div>
                        )
                    }
                    
                </ThemeProvider>
            </div>
        );
    }
}

export default withStyles(styles)(Recommendation);